
import lineChart from 'assets/img/illustrations/crm-line-chart.png';
import Flex from 'components/common/Flex';
import PropTypes from 'prop-types';
import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';

const TitleSelectorSupportrDesk = ({
    title1,
    title2,
    barChart,
    barChartWidth = 90,
    barChartClassName = 'ms-n4'
}) => {

    return (
        <Card className="bg-100 shadow-none border mb-3 overflow-hidden">
            <Card.Body className="py-2">
                <Row className="g-0 justify-content-between">
                    <Col sm="auto">
                        <Flex alignItems="center">
                            <img
                                src={barChart}
                                width={barChartWidth}
                                alt=""
                                className={barChartClassName}
                                style={{ maxHeight: barChartWidth, objectFit: 'contain' }}
                            />
                            <div>
                                <h4 className="text-primary fw-bold mb-0">
                                    {title1}
                                    <span className="text-info fw-medium"> {title2}</span>
                                </h4>
                            </div>
                            <img
                                src={lineChart}
                                width={140}
                                alt="..."
                                className="ms-n4 d-md-none d-lg-block"
                            />
                        </Flex>
                    </Col>
                    <Col md="auto" className="mb-1 mt-1 mb-md-3">

                    </Col>
                </Row>
            </Card.Body>
        </Card>
    );
};


TitleSelectorSupportrDesk.propTypes = {
    title1: PropTypes.string,
    title2: PropTypes.string,
    barChart: PropTypes.string,
    barChartWidth: PropTypes.number,
    barChartClassName: PropTypes.string
};


export default TitleSelectorSupportrDesk;